import { getDataFromCookies, getDataFROMLS } from "../utils";

export const currentGroup = getDataFROMLS("ngStorage-currentGroup");
export let CURRENT_ROLE = JSON.parse(getDataFROMLS("ngStorage-currentRole"));
// if (process.env.REACT_APP_MY_ENVIRONMENT === "production") {
// CURRENT_ROLE = JSON.parse(getDataFROMLS("ngStorage-currentRole"));
// } else {
// CURRENT_ROLE = getDataFROMLS("ngStorage-currentRole");
// }
export const GROUPS = JSON.parse(getDataFROMLS("groups"));

export const currentGroupName = () => {
  let grpName = GROUPS.filter((obj) => {
    if (obj.id === parseInt(currentGroup)) {
      return obj;
    }
  });
  return grpName[0].name;
};
// currentGroupName();
export const BASE_URL = process.env.REACT_APP_MY_ENV_VARIABLE;
export const UI_BASE_URL =process.env.NODE_ENV==='development'?"http://localhost:3000":process.env.REACT_APP_MY_ENV_VARIABLE;
export const USER_EMAIL = process.env.REACT_APP_MY_EMAIL; //Only use for development phase
export const USER_PASSWORD = process.env.REACT_APP_MY_PASSWORD; // Only use for development phase

export const LOGIN_URL = "/user/login";
export const LOGOUT_URL = "/user/logout";
export const PROFILE_DATA = (groupId) => {
  return `/user/group/${groupId}/getprofile`;
};
export const PROFILE_DATA_SEEKER_AWARDS = (groupId) => {
  return `/user/group/${groupId}/getprofile?role=Seeker`;
};
export const PROFILE_DATA_SEEKER_AWARDS_2 = `/user/group/${currentGroup}/getprofile?role=${CURRENT_ROLE}`;
export const AUTO_SUGGEST = `question/group/${currentGroup}/auto-suggest`;
export const SEARCH_DATA_URL = `/question/group/${currentGroup}/search`;
export const GET_IMAGE_ATTACHMENT_URL = `expert/group/${currentGroup}/getexpertattachments`;
export const GET_USER_PROFILE_PIC = `user/getprofilepic`;
export const FAVOURITE_QA = (questionUuid) => {
  return `/user/question/${questionUuid}/${currentGroup}/favourite`;
};
export const GET_ANSWER_RATING = (answerIds, docId) => {
  if (answerIds.length > 0 && docId.length > 0) {
    return `question/group/${currentGroup}/answerratings?answerids=${answerIds.toString()}&docids=${docId.toString()}`;
  }
  if (answerIds.length > 0 && docId.length === 0) {
    return `question/group/${currentGroup}/answerratings?answerids=${answerIds.toString()}`;
  }
  if (answerIds.length === 0 && docId.length > 0) {
    return `question/group/${currentGroup}/answerratings?docids=${docId.toString()}`;
  }
};

export const RATE_ANSWER = `question/group/${currentGroup}/rate`;
export const DETECT_DOMAIN = `question/group/${currentGroup}/detectdomain`;
export const GET_WATCHLIST_USER = (text, internal, role) => {
  return `/user/group/${currentGroup}/fetchusers?search=${text}${
    internal !== "" ? `&internal=${internal}` : ""
  }${role !== "" && role !== undefined && role ? `&role=${role}` : ""}`;
};
export const ASK_QUESTION = `question/group/${currentGroup}/ask`;
export const REQUEST_FOR_UPDATE = `question/group/${currentGroup}/search-feedback`;
export const SHARE_QUESTION = `question/group/${currentGroup}/sharequestion`;
export const SEARCH_HISTORY = (pageNo, sortOrder) => {
  return `question/group/${currentGroup}/mysearchhistory?page=${pageNo}&sortOrder=${sortOrder}`;
};
export const OPEN_QUESTIONS = (
  page,
  status,
  sortFilter,
  sortOrder,
  sortChange,
  domainFilter
) => {
  return `question/group/${currentGroup}/pages?page=${page}&status=${status}&sortFilter=${sortFilter}&sortOrder=${sortOrder}&sortChange=${sortChange}&domainFilter=${encodeURIComponent(
    domainFilter
  )}`;
};
export const UPDATE_QUESTIONTEXT = `/cmuser/group/${currentGroup}/updateqarecord`;
export const DELETE_QUESTION = `/cmuser/group/${currentGroup}/deletequestionrecord`;
export const ADD_TO_WATCHLIST = `/question/group/${currentGroup}/editwatchlist`;
export const TAB_SEARCH_OPEN = `/question/group/${currentGroup}/tab-search`;
export const ALL_NOTIFICATIONS = `/user/group/${currentGroup}/notifications`;
export const CLEAR_NOTIFICATION = `/user/clearnotifications`;
export const NOTIFICATION_ACTION = `question/group/${currentGroup}/notifications`;
export const GET_INLINE_IMAGE = (answerUuidStr) => {
  return `/expert/group/${currentGroup}/getinlineimages?answerUuidStr=${answerUuidStr}`;
};
export const FOLLOW_UP = `question/group/${currentGroup}/answerfollowup`;
export const PAGES_API = (
  pageNo,
  sortFilter,
  sortOrder,
  sortChange,
  domains,
  status
) => {
  return `question/group/${currentGroup}/pages?page=${pageNo}&status=${status}&sortFilter=${sortFilter}&sortOrder=${sortOrder}&sortChange=${sortChange}&domainFilter=${encodeURIComponent(
    domains
  )}`;
};
export const TAB_SEARCH = `/question/group/${currentGroup}/tab-search`;
export const GET_FILES = `/expert/group/${currentGroup}/getfiles`;
export const GET_USER_BADGES = `/user/group/${currentGroup}/getuserbadges`;
export const UPDATE_VIEW_COUNT = `/question/group/${currentGroup}/updateviewcount`;
export const RECOMMEND_API = `/question/group/${currentGroup}/recommend`;
export const FAVOURITE_API = (
  pageNo,
  sortFilter,
  sortOrder,
  sortChange,
  domains,
  category,
  status
) => {
  return `question/group/${currentGroup}/${status}?page=${pageNo}&category=${category}&sortFilter=${sortFilter}&sortOrder=${sortOrder}&sortChange=${sortChange}&domainFilter=${encodeURIComponent(
    domains
  )}`;
};

export const KEYTAG_QA_API = (pageNo, tagStr, queryType, searchQuery) => {
  return `question/group/${currentGroup}/keytagsqadata?page=${pageNo}&tag=${tagStr}&type=${queryType}&search=${searchQuery}`;
};

export const KEY_TERM = (pageNo, domain, tag, words) => {
  return `question/group/${currentGroup}/keytags?page=${pageNo}&domain=${encodeURIComponent(
    domain
  )}&tag=${tag}&words=${words}`;
};
export const UPDATE_PROFILE = `/user/group/${currentGroup}/updateprofile`;
export const SET_PROFILE_PICTURE = `/user/setprofilepic`;
export const ACTIVITY_INFO = `/question/group/${currentGroup}/activityinfo`;
export const VALIDATE_QUESTION = (type, id) => {
  return `/question/validatequestionowner?quesUuid=${id}&type=${type}`;
};
export const URL_REDIRECTION_DATA_API = (id) => {
  return `/question/group/${currentGroup}/${id}`;
};
//API Calls for Expert start//
export const EXPERT_OPEN_DATA = (
  pageNo,
  sortFilter,
  sortOrder,
  sortChange,
  domainFilter,
  ownRecords
) =>
  `/expert/group/${currentGroup}/expertopen?page=${pageNo}&status=open&sortFilter=${sortFilter}&sortOrder=${sortOrder}&sortChange=${sortChange}&domainFilter=${encodeURIComponent(
    domainFilter
  )}&ownRecords=${ownRecords}`;
export const TAB_SEARCH_EXPERT_OPEN = `/question/group/${currentGroup}/expert-tab-search`;
export const FETCH_FORCE_REROUTE = (questionId, domainId) =>
  `/cmuser/group/${currentGroup}/fetchforcerouteusers?questionId=${questionId}&domainid=${domainId}`;
export const CHANGE_DOMAIN = `/expert/group/${currentGroup}/changedomain`;
export const FORCE_REROUTE = `/cmuser/group/${currentGroup}/forceroute`;
export const EXPERT_DECLINE = `/expert/group/${currentGroup}/acknowledge`;
export const ASK_CLARIFICATION = `/expert/group/${currentGroup}/askclarification`;
//API Calls for Expert end//

export const EXPERT_ANSWERED_API = (
  pageNo,
  sortFilter,
  sortOrder,
  sortChange,
  domains,
  status,
  category,
  isTransferred,
  curationStatus
) => {
  
  return `expert/group/${currentGroup}/expertrecordsbypage?page=${pageNo}&status=${status}&sortFilter=${sortFilter}&sortOrder=${sortOrder}&sortChange=${sortChange}&domainFilter=${encodeURIComponent(
    domains
  )}&curationcategory=${category}&transferred=${isTransferred}&curationstatus=${curationStatus}`;
};

// export const EXPERT_ANSWERED_COUNT= (
//   pageNo,
//   sortFilter,
//   sortOrder,
//   sortChange,
//   // domains,
//   // status,
//   // category,
//   // isTransferred,
//   // curationStatus,
// ) => {
  
//   return `expert/group/${currentGroup}/expertrecordsbypage?page=${pageNo}&status=answered&count=true&sortFilter=${sortFilter}&sortOrder=${sortOrder}&sortChange=${sortChange}&domainFilter`;
// };

export const EXPERT_ANSWERED_COUNTS=`/report/group/${currentGroup}/fetchexpertwisecurationcount?currentUser=true`

export const EXPERT_TAB_SEARCH = `/question/group/${currentGroup}/expert-tab-search`;
export const CURATION_STATUS_URL = `/cmuser/group/${currentGroup}/updatecurationstatus`;
export const EXPERT_GET_DRAFT_DATA = (id) => {
  return `/expert/draft/${id}`;
};
export const EXPERT_SEND_DRAFT_DATA = `/expert/draft`;
export const EXPERT_ANSWER_QUESTION_API = `/expert/group/${currentGroup}/answer`;
export const EXPERT_UPDATE_ANSWER_API = `/cmuser/group/${currentGroup}/updateqarecord`;

/* APIs for my stats start */
export const EXPERT_RANK = `/report/group/${currentGroup}/expertrank`;
export const VIEW_COUNT_STATS = `/report/group/${currentGroup}/viewcountstats`;
export const SLA_COMPLIANCE = `/report/group/${currentGroup}/slacompliance`;
export const EXPERT_SCORE = `/report/group/${currentGroup}/expertscore`;
export const AVG_RES_TIME = `/report/group/${currentGroup}/avgresponsetime`;
export const RECENT_RATINGS = `/report/group/${currentGroup}/recentratings`;
export const BEST_RATINGS = `/report/group/${currentGroup}/bestratings`;
export const WORST_RATINGS = `/report/group/${currentGroup}/worstratings`;
export const BETTER_RATINGS = `/report/group/${currentGroup}/betterratings`;
export const DOMAIN_BY_EXPERTS = (id, geoLevelValue, bool, domainId) =>
  `/report/group/${currentGroup}/domainbyexpert?geoLevelId=${id}&geoLevelValue=${geoLevelValue}&userSpecific=${bool}&domainid=${domainId}`;

export const GET_RATINGS_GROUPS = (id, geoLevelValue, bool, domainIds) =>
  `/report/group/${currentGroup}/getratinggroupsbygeo?geoLevelId=${id}&geoLevelValue=${geoLevelValue}&userSpecific=${bool}` +
  // `${domainIds !== "" ? `&domainid=${domainIds}` : ``}`;
  `${`&domainid=${domainIds}`}`;
export const TOTAL_ANSWERED_TREND = `/report/group/${currentGroup}/totalansweredtrend`;
export const EXPERT_SCORE_TREND = `/report/group/${currentGroup}/expertscoretrend`;
export const SLA_COMPLIANCE_TREND = `/report/group/${currentGroup}/compliancetrend`;
export const RESPONSE_TIME_TREND = `/report/group/${currentGroup}/responsetimetrend`;
export const CREATE_QA_PAIR = `/expert/group/${currentGroup}/createqapair`;

/* APIs for my stats end */

export const NEW_TRENDING_API = (
  pageNo,
  sort,
  order,
  domains,
  expertindex,
  threadindex,
  searchindex,
  viewindex,
  acceptedindex
) => {
  return `question/group/${currentGroup}/trending?page=${pageNo}&sort=${sort}&order=${order}&domains=${encodeURIComponent(
    domains
  )}&expertindex=${expertindex}&threadindex=${threadindex}&searchindex=${searchindex}&viewindex=${viewindex}&acceptedindex=${acceptedindex}`;
};

export const DELETE_ANSWER_RECORD_API = `cmuser/group/${currentGroup}/deleteanswerrecord`;

export const DECLINED_ANSWERS_API = (id) => {
  return `expert/group/${currentGroup}/declinedquestions/${id}`;
};

export const EXPERT_OPEN_URL_REDIRECTION = (id) => {
  return `expert/group/${currentGroup}/expertrecordsbypage/${id}?&status=open`;
};
export const GENERATE_TEXT = `question/group/${currentGroup}/generatetext`;
export const GET_EXPERT_OVERVIEW_ANALYTICS = (
  geoLevelId,
  geoLevelValue,
  domainIds
) =>
  `/report/group/${currentGroup}/getexpertanalytics?geoLevelId=${geoLevelId}&geoLevelValue=${geoLevelValue}&domainid=${domainIds}`;
export const CM_ATOMIZER_API = (type) => {
  return `cmuser/group/${currentGroup}/atomizer/jobs?type=${type}`;
};
/* APIs for CM start */
export const FETCH_GDRIVE_FREQUENCY = `cmuser/group/${currentGroup}/fetchgdrivefrequency`;
export const FETCH_GDRIVE_DOCUMENTS = `/cmuser/group/${currentGroup}/fetchgdrivedocs`;
export const SOURCE_DOCS = `/cmuser/group/${currentGroup}/sourcedocs`;
export const UPDATE_GDRIVE_ATTR = `/cmuser/group/${currentGroup}/updategdriveatrs`;
export const GET_SEARCH_SUGGESTIONS = `/cmuser/group/${currentGroup}/fetchcmsearchrecords`;
export const SEARCH_SUGGESTIONS_COUNT = `/cmuser/group/${currentGroup}/fetchcmsearchrecordscount`;
export const DELETE_SEARCH_SUGGESTION_RECORD = `/cmuser/group/${currentGroup}/deletevizquestionrecord`;
export const DATA_EXPORT = (type) =>
  `'/cmuser/group/${currentGroup}/dataexport?type=${type}`;
export const SEARCH_SUGGESTION_DETAIL = (questionUuid) =>
  `/question/group/${currentGroup}/fetchsearchsuggestiondetails?topicid=${questionUuid}`;
export const GET_EXPERTS_QCOUNTS = (domainIds) =>
  `/report/group/${currentGroup}/expertsbyqcount?domainid=${domainIds}`;
export const FETCH_CURATION_GRAPH_DATA = (
  geoLevelId,
  geoLevelValue,
  domainIds,
  category,
  order
) =>
  `/report/group/${currentGroup}/fetchexpertwisecurationcount?geoLevelId=${geoLevelId}&geoLevelValue=${geoLevelValue}&domainid=${domainIds}&category=${category}&order=${order}`;
export const DOMAIN_SPECIFIC_GRAPH = (
  domain,
  duration,
  geoLevelId,
  geoLevelValue,
  domainId,
  userType
) =>
  `/report/group/${currentGroup}/domaintimelineby${
    duration !== null ? `time` : `day`
  }?domain=${encodeURIComponent(domain)}${
    duration !== null ? `&duration=${duration}` : ``
  }&geoLevelId=${geoLevelId}&geoLevelValue=${geoLevelValue}&domainid=${domainId}&usertype=${
    userType === null ? `` : userType
  }`;
/* GRAPHS FOR OVERVIEW EXCLUDING EXPERT */
export const GET_AUDIT_LOGS = (
  duration,
  action,
  geoLevelId,
  geoLevelValue,
  domainIds,
  userType,
  actionName
) =>
  `/report/group/${currentGroup}/getauditlogstats${
    duration !== null ? `weeks` : `days`
  }?${duration !== null ? `duration=${duration}` : ""}${
    duration !== null ? `&action=${action}` : `action=${action}`
  }&geoLevelId=${geoLevelId}&geoLevelValue=${geoLevelValue}&domainid=${domainIds}&usertype=${
    userType === null ? `` : userType
  }&actionName=${actionName}`;
export const QUESTIONS_SEARCHED_COUNT = (
  geoLevelId,
  geoLevelValue,
  duration,
  source,
  domainId,
  userType
) =>
  `/report/group/${currentGroup}/questionssearchedcountby${
    duration !== null ? `week` : `day`
  }?geoLevelId=${geoLevelId}&geoLevelValue=${geoLevelValue}${
    duration !== null ? `&duration=${duration}` : ""
  }&source=${source}&domainid=${domainId}&usertype=${
    userType === null ? `` : userType
  }`;
export const GET_DOMAINS_TIMELINE = (
  duration,
  geoLevelId,
  geoLevelValue,
  domainIds,
  userType
) =>
  `/report/group/${currentGroup}/alldomainstimelineby${
    duration !== null ? `time` : `day`
  }?${duration !== null ? `duration=${duration}` : ""}${
    duration !== null ? `&` : ``
  }geoLevelId=${geoLevelId}&geoLevelValue=${geoLevelValue}&domainid=${domainIds}&usertype=${
    userType === null ? `` : userType
  }`;
export const GET_QUESTIONS_COUNT_BY_DAY = (
  duration,
  geoLevelId,
  geoLevelValue,
  domainIds,
  userType
) =>
  `/report/group/${currentGroup}/questionscountby${
    duration !== null ? `time` : `day`
  }?${
    duration !== null ? `duration=${duration}&` : ""
  }geoLevelId=${geoLevelId}&geoLevelValue=${geoLevelValue}&domainid=${domainIds}&usertype=${
    userType === null ? `` : userType
  }`;
export const GET_DOMAIN_WISE_COUNT = (
  geoLevelId,
  geoLevelValue,
  domainIds,
  userType
) =>
  `/report/group/${currentGroup}/domainsbyqcount?geoLevelId=${geoLevelId}&geoLevelValue=${geoLevelValue}&domainid=${domainIds}&usertype=${
    userType === null ? `` : userType
  }`;
/* GRAPHS FOR OVERVIEW EXCLUDING EXPERT */
export const GET_DOMAINS_COUNT_GRAPHS = (
  geoLevelId,
  geoLevelValue,
  domainId,
  userType
) =>
  `/report/group/${currentGroup}/alldomainstimelinebyday?geoLevelId=${geoLevelId}&geoLevelValue=${geoLevelValue}&domainid=${domainId}&usertype=${userType}`;
/* APIs for CM end */

export const CM_JOBS_REVIEW_API = `/cmuser/group/${currentGroup}/atomizer/job`;
export const Atomizer_Url = `/cmuser/group/${currentGroup}/fetchcrawlingfrequency`;

export const postPdf = `/cmuser/group/${currentGroup}/atomizer/parsefile`;

export const scrapUrl = `/cmuser/group/${currentGroup}/atomizer/crawlurl`;
export const QA_Url = `/cmuser/group/${currentGroup}/uploadcsv`;

export const bloomFire = `cmuser/group/${currentGroup}/ingestbloomfiredoc`;

export const getBloomFire = `cmuser/group/${currentGroup}/fetchbloomfirecategories`;

export const postBloonfire = `/cmuser/group/${currentGroup}/ingestbloomfirecategories`;
export const GET_WATCHLIST_USER_CM_ATOMIZER = (text, role) => {
  return `/user/group/${currentGroup}/fetchusers?search=${text}&role=${role}`;
};
export const ADMIN_ROUTING_LEVELS_DATA = `admin/group/${currentGroup}/getroutinglevels`;
export const ADMIN_GEOLEVELS = `admin/group/${currentGroup}/getgeolevels`;
export const CM_EXPERT_RECORDS_COUNT = `cmuser/group/${currentGroup}/fetchcmexpertrecordscount`;
export const CM_EXPERT_RECORDS = `cmuser/group/${currentGroup}/fetchcmexpertrecords`;
export const CM_DETAILED_RECORDS = `question/group/${currentGroup}/fetchquestionanswers`;
export const GET_ROUTING_HISTORY = `cmuser/group/${currentGroup}/checkroutinghistory`;
export const CM_OVERVIEW_TOTAL_QUESTION_COUNT = (id, value, domain, type) => {
  return `report/group/${currentGroup}/totalquestionscount?geoLevelId=${id}&geoLevelValue=${value}&domainid=${domain}${
    type !== null ? `&usertype=${type}` : ``
  }`;
};

export const CM_OVERVIEW_USER_COUNT = (id, value, domain, usertype) => {
  return `admin/group/${currentGroup}/usercounts?levelid=${id}&levelvalue=${value}&domainid=${domain}${
    usertype !== null ? `&usertype=${usertype}` : ``
  }`;
};

export const seekerAnalytics = (
  geoLevelId,
  geoLevelValue,
  userType,
  domainId
) => {
  return `/report/group/${currentGroup}/getseekeranalytics?geoLevelId=${geoLevelId}${
    geoLevelValue !== undefined || ""
      ? `&geoLevelValue=${geoLevelValue}`
      : `&geoLevelValue=`
  }&usertype=${userType === null ? `` : userType}${
    domainId !== undefined ? `&domainid=${domainId}` : `&domainid=""`
  }
 `;
};
export const seekerBadges = (
  geoLevelId,
  geoLevelValue,
  userType,
  domainId,
  filter,
  page,
  searchText,
  entryCount
) => {
  return `/report/group/${currentGroup}/seekerbadges?geoLevelId=${geoLevelId}${
    geoLevelValue !== undefined || ""
      ? `&geoLevelValue=${geoLevelValue}`
      : `&geoLevelValue=`
  }&usertype=${userType}&filter=${filter}&page=${page}&searchtext=${searchText}&entrycount=${entryCount}`;
};

export const seekeranalyticsque = (
  geoLevelId,
  geoLevelValue,
  userType,
  domainId,
  filter,
  page,
  searchText,
  entryCount
) => {
  return `/report/group/${currentGroup}/getseekeranalyticsque?geoLevelId=${geoLevelId}&domainid=${domainId}${
    geoLevelValue !== undefined || ""
      ? `&geoLevelValue=${geoLevelValue}`
      : `&geoLevelValue=`
  }${
    userType !== undefined || "" ? `&usertype=${userType}` : `&usertype=""`
  }&filter=${filter}&page=${page}&searchtext=${searchText}&entrycount=${entryCount}`;
};

export const expertanalytics = (geoLevelId, geoLevelValue, domainId) => {
  return `/report/group/${currentGroup}/getexpertanalytics?geoLevelId=${geoLevelId}${
    geoLevelValue !== undefined || ""
      ? `&geoLevelValue=${geoLevelValue}`
      : `&geoLevelValue=`
  }${domainId !== undefined ? `&domainid=${domainId}` : `&domainid=""`}
 `;
};
export const ExpertRankUrl = `/report/group/${currentGroup}/expertrank`;
export const expertWiseCuration = (
  geoLevelId,
  geoLevelValue,
  domainId,
  Category,
  order
) => {
  return `/report/group/${currentGroup}/fetchexpertwisecurationcount?geoLevelId=${geoLevelId}${
    geoLevelValue !== undefined || ""
      ? `&geoLevelValue=${geoLevelValue}`
      : `&geoLevelValue=`
  }&domainid=${domainId}&category=${Category}&order=${order}`;
};
export const JOB_API = `cmuser/group/${currentGroup}/atomizer/job`;
export const DELETE_JOBS = `cmuser/group/${currentGroup}/atomizer/deletedata`;
export const VERIFIED_DOCS = `cmuser/group/${currentGroup}/getexpertverifieddocs?soid=`;
export const DOWNLOAD_HEADERS = (soid, type) => {
  return `cmuser/group/${currentGroup}/generateqa?soid=${soid}&type=${type}`;
};
export const AMEND_HEADERS = (soid) => {
  return `cmuser/group/${currentGroup}/amendheaders?soid=${soid}`;
};
export const GET_CRAWL_DOCS = `/cmuser/group/${currentGroup}/fetchcrawleddocs`;
export const GET_UPLOADED_CSV = `/cmuser/group/${currentGroup}/uploadedcsvs`;
export const EDIT_DATA_API = `/cmuser/group/${currentGroup}/atomizer/editdata`;
export const DELETE_DATA_API = `/cmuser/group/${currentGroup}/atomizer/deletedata`;

export const RFP_UPLOAD = `question/group/${currentGroup}/rfpupload`;
export const RFP_DOC = `question/group/${currentGroup}/fetchrfpdocuments`;
export const GET_ANSWER_RATING_CM = `question/group/${currentGroup}/answerratings`;

export const Document_Tab = (
  geoLevelId,
  geoLevelValue,
  domainId,
  userType,
  channelId,
  channel
) =>
  `/cmuser/group/${currentGroup}/cmdocuments?levelid=${geoLevelId}&levelvalue=${geoLevelValue}&domainid=${domainId}&usertype=${userType}${
    channel ? `&channelid=${channelId}` : ""
  }`;

export const GET_FORCE_REROUTE_USER = `cmuser/group/${currentGroup}/fetchforcerouteusers`;
export const TRANSFER_OWNERSHIP = `cmuser/group/${currentGroup}/transferownership`;
export const REROUTE_RECORD = `cmuser/group/${currentGroup}/rerouterecord`;
export const CM_ANSWER = `expert/group/${currentGroup}/answerbycm`;
export const CM_EXPEDITE = `cmuser/group/${currentGroup}/expediteanswerprocess`;
export const CM_DELETE_ANSWER = `cmuser/group/${currentGroup}/deleteanswerrecord`;
export const GET_WATCHLIST_USER_DEMOTED = (text) => {
  return `/user/group/${currentGroup}/fetchusers?search=${text}&demoted=${false}`;
};
export const ADMIN_PERMISSION = `/admin/permissions`;
export const EXPERT_GENERATE_QA = `expert/group/${currentGroup}/generateqapair`;
export const ADMIN_USER_LIST = (page, size, sortfilter, sortorder, text, levelid, levelval, usertype, role,from,till,domain,statusList,activefrom,activetill) => {
  return `/admin/group/${currentGroup}/userlist?page=${page}&size=${size}&sortfilter=${sortfilter}&sortorder=${sortorder}&search=${text}&levelid=${levelid}&levelvalue=${levelval}&usertype=${usertype}&role=${role}&fromdate=${from}&tilldate=${till}&domainids=${domain}&status=${statusList}&lastActiveFrom=${activefrom}&lastActiveTill=${activetill}`;
};
export const REGENERATE_GENAI = `question/group/${currentGroup}/regenerategenaianswer`;
export const USER_INACTIVE_TOGGLE = `admin/group/${currentGroup}/toggleactive`;
export const USER_INVITE_API = `admin/group/${currentGroup}/sendnewinvites`;
export const USER_REMOVE_FROM_GROUP = (userUuid) => {
  return `admin/group/${currentGroup}/user/${userUuid}/remove`;
};
export const FETCH_ROLES = `admin/fetchroles?fetchpermissions=false`;
export const ADMIN_DOWNLOAD_USER = `${BASE_URL}/admin/group/${currentGroup}/downloadusers`;
export const ADMIN_DOWNLOAD_USER_2 = (sortfilter, sortorder, text, levelid, levelval, usertype, role,from,till,domain,statusList,activefrom,activetill) => {
  return `${BASE_URL}/admin/group/${currentGroup}/downloadusers?sortfilter=${sortfilter}&sortorder=${sortorder}&search=${text}&levelid=${levelid}&levelvalue=${levelval}&usertype=${usertype}&role=${role}&fromdate=${from}&tilldate=${till}&domainids=${domain}&status=${statusList}&lastActiveFrom=${activefrom}&lastActiveTill=${activetill}`;
};
export const GET_USER_ATTR = `admin/group/${currentGroup}/getuserroutingatrs?userid=`;
export const GET_TIMEZONES = `user/getavailabletimezones`;
export const CONFIG_USER_ATTR= `admin/group/${currentGroup}/configureuserroutingatrs`;

export const ADMIN_MANAGE_ROLE = `/admin/fetchroles?fetchpermissions=true`;

export const CREATE_NEW_ROLE = "/admin/permissions";
export const DELETE_ROLE = "/admin/deleterole";
export const EDIT_ROLE = (roleName) => {
  return `/admin/editrole?namechanged=${roleName}`;
};

export const CREATE_ROLE = `/admin/createrole`;
export const Level_Action_Restriction = `/admin/group/${currentGroup}/getlevelactionrestrictions`;
export const UpdateRestriction = `/admin/group/${currentGroup}/updatelevelactionrestriction`;
export const getRegion = (value, geoLevelId) =>
  `/admin/group/${currentGroup}/getparentatrs?level=${geoLevelId}&value=${value}`;

export const updatePermission = (value) =>
  `/admin/updatepermission?action=${value}`;
export const ADMIN_GET_GROUP_INFO = `/admin/group/${currentGroup}/getgroupinfo`;
export const ADMIN_GET_ROUTING_LEVELS = `/admin/group/${currentGroup}/getroutinglevels`;
export const ADMIN_GET_CURATION_ROUTING_VALUES = `/admin/getcurationroutinglookupvalues`;
export const ADMIN_GET_CURATION_ROUTING_GROUP_WISE = `/admin/group/${currentGroup}/getcurationroutinglookupvalues`;
export const ADMIN_UPDATE_ROUTING_LEVELS = `/admin/group/${currentGroup}/updateroutinglevels`;
export const ADMIN_UPDATE_GROUP_INFO = `/admin/group/${currentGroup}/updategroupinfo`;
export const UPDATE_CURATION_ROUTING_POINT = `/admin/group/${currentGroup}/updatecurationroutingpoint`;

export const EmailIntegration =(pageNo)=> `/ticket/group/${currentGroup}/emailthreadsubjects?page=${pageNo}`;
export const Email_Thread_QA=(ticketId)=>`/ticket/group/${currentGroup}/emailqapairs?ticketid=${ticketId}`
export const updateDeleteEmailQaPair=`/ticket/group/${currentGroup}/updateticketemailqapairs`;
export const NEW_TRENDING_API_TWO = `/question/group/${currentGroup}/trendingrecords`;
export const GET_KEY_TAGS = `/question/group/${currentGroup}/fetchquestionkeytags`;
export const GET_AGENT_PLANNING = `/question/group/${currentGroup}/agenticflow`;
export const SAVE_AGENT_BRIEF = `/question/group/${currentGroup}/saveagentic?`;
export const AGENT_BRIEF_HISTORY = `/question/group/${currentGroup}/agentichistory?`;
export const GET_EXTERNAL_LINK_DATA = `/question/group/${currentGroup}/externalsearch`;
export const AGENT_BRIEF_DELETE = `/question/group/${currentGroup}/deleteagentic?`;
export const GET_TICKET_RECORDS = (pageNo, status, category, sort,search,assignee,subject,ticketId,emailBody,from) => {
  return `/ticket/group/${currentGroup}/ticketrecords?page=${pageNo}&status=${status}&category=${category}&searchText=${search}&sort=${sort}&assignee=${assignee}&subject=${subject}&from=${from}&emailBody=${emailBody}&ticketId=${ticketId}`;
}
export const TICKET_DETAIL = (ticketId) => {
  return `/ticket/group/${currentGroup}/ticketdetails?ticketId=${ticketId}`;
}

export const TICKET_UNREAD_READ = `/ticket/toggleticketasread`;
export const TICKET_UNREAD_READ_2 = `/ticket/toggleticketasunread`;
export const CATEGORY_EXPERT = `/ticket/group/${currentGroup}/fetchcategoryexperts`;
export const TICKET_ASSIGN = `/ticket/assigncategories`;
export const APP_STATUS = `/status/currentstatus`;
export const INCIDENT = `/status/getIncident?`;
export const CREATE_INCIDENT = `/incident/createIncident`;
export const EMAIL_ACTION = `/question/emailaction`;

export const EXPERT_OPEN_QUESTION = `/expert/group/${currentGroup}/expertopen?page=0&status=open&sortFilter=questionAsked&sortOrder=desc&sortChange=false&domainFilter=&ownRecords=true&`;




